import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

const CopyIcon = ({ width = 25, height = 24, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      {hovered && (
        <path
          d='M19.2534 18.5299C19.2534 18.8146 19.0205 19.0475 18.7358 19.0475H6.82953V3.51766C6.82953 3.23295 7.06248 3 7.34719 3H12.5238H18.7358C19.0205 3 19.2534 3.23295 19.2534 3.51766V18.5299Z'
          fill={fill}
        />
      )}
      <path
        d='M13.5463 4.95248L17.17 8.83495V9.86998V20.4823C17.17 20.7671 16.937 21 16.6523 21H11.4757H5.26376C4.97904 21 4.74609 20.7671 4.74609 20.4823V5.47015C4.74609 5.18543 4.97904 4.95248 5.26376 4.95248H13.5463Z'
        fill='white'
      />
      <path
        d='M18.7358 19.0475C19.0205 19.0475 19.2534 18.8146 19.2534 18.5299V3.51766C19.2534 3.23295 19.0205 3 18.7358 3H12.5238H7.34719C7.06248 3 6.82953 3.23295 6.82953 3.51766'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.17 9.86998V8.83495L13.5463 4.95248H5.26376C4.97904 4.95248 4.74609 5.18543 4.74609 5.47015V20.4823C4.74609 20.7671 4.97904 21 5.26376 21H11.4757H16.6523C16.937 21 17.17 20.7671 17.17 20.4823V12.004'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.1695 8.83495H13.8047C13.6624 8.83495 13.5459 8.71848 13.5459 8.57612V7.02313'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CopyIcon;
